/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import Media from 'react-media';

import classnames from 'classnames';

import { Grid, breakpoints } from '@coursera/cds-core';

import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';
import DeadlineInfo from 'bundles/xddp/components/homepage/DeadlineInfo';
import StackabilitySidebarInfo from 'bundles/xddp/components/homepage/StackabilitySidebarInfo';
import type { AtAGlanceProps, UpsellsByDegreeSlug, UserAgentProps } from 'bundles/xddp/types';

type Props = UserAgentProps & {
  atAGlance?: Maybe<AtAGlanceProps>;
  stackableItems?: UpsellsByDegreeSlug;
};

const InfoSidebar = ({ atAGlance, userAgent, stackableItems }: Props & UserAgentProps) => {
  if (!atAGlance) return null;

  return (
    <Media query={{ minWidth: breakpoints.values.md }} defaultMatches={userAgent?.isMobileBrowser}>
      {(matches) => (
        <Grid lg={3} md={4} sm={12} item>
          <div
            className={classnames('rc-InfoSideabar', { 'rc-Section': matches })}
            css={
              matches
                ? css`
                    margin-left: 24px;
                  `
                : css`
                    margin-bottom: 32px;
                  `
            }
          >
            <DeadlineInfo finalDeadlineInfo={atAGlance.finalDeadlineInfo} />
          </div>
          <div
            className={classnames('rc-InfoSideabar', { 'rc-Section': matches })}
            css={
              matches
                ? css`
                    margin-left: 24px;
                  `
                : css`
                    margin-bottom: 24px;
                  `
            }
          >
            <StackabilitySidebarInfo stackableItems={stackableItems} />
          </div>
        </Grid>
      )}
    </Media>
  );
};

export default React.memo(InfoSidebar);
